import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import BenefitFetchingParameters from "../models/Benefit/BenefitFetchingParameters";
import BenefitIntegrationData from "../models/Benefit/BenefitIntegrationData";

const benefitsUrlPrefix = "benefits";

export const benefitApi = createApi({
  reducerPath: "benefitApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (build) => ({
    getIntegrationBenefitData: build.mutation<
      BenefitIntegrationData[],
      BenefitFetchingParameters[]
    >({
      query: (benefitFetchingParameters) => ({
        url: `${benefitsUrlPrefix}/integration-data`,
        method: "post",
        data: benefitFetchingParameters,
      }),
    }),
  }),
});

export const { useGetIntegrationBenefitDataMutation } = benefitApi;
